<template>
  <div class="modal skin-modal">
    <div class="overlay" @click="close"></div>
    <div class="wrapper">
      <img class="close" @click="close" src="./../assets/close.svg" />
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="title title-24">
                <b v-if="!ibanFormVisible && !successVisible"
                  >CONTACT INFORMATION</b
                >
                <b v-else-if="ibanFormVisible && !successVisible"
                  >IBAN TRANSFER</b
                >
                <b v-else-if="successVisible">SUCCESS</b>
              </div>

              <!-- Success Message -->
              <div class="form-fields-wrapper third-step" v-if="successVisible">
                <div style="text-align: center; padding: 40px 20px">
                  <div
                    class="desc green"
                    style="font-size: 18px; margin-bottom: 20px"
                  >
                    ✅ Payout request submitted successfully!
                  </div>
                  <div class="desc" style="margin-bottom: 30px">
                    Your payout request has been processed and you will receive
                    the payment soon.
                  </div>
                  <button class="button" @click="close">
                    <span>Close</span>
                  </button>
                </div>
              </div>

              <!-- Step 1: Contact Information -->
              <div
                class="form-fields-wrapper"
                v-if="!ibanFormVisible && !successVisible"
              >
                <div class="input-container">
                  <div class="desc">Name:</div>
                  <input type="text" placeholder="Name" v-model="name" />
                </div>
                <div class="input-container">
                  <div class="desc">Surname:</div>
                  <input type="text" placeholder="Surname" v-model="surname" />
                </div>
                <div class="input-container">
                  <div class="desc">E-mail address:</div>
                  <input
                    type="email"
                    placeholder="E-mail address"
                    v-model="email"
                  />
                </div>
                <div class="input-container">
                  <div class="desc">Phone:</div>
                  <input type="tel" placeholder="Phone" v-model="phone" />
                </div>
                <div class="input-container">
                  <div class="desc">Country:</div>
                  <Select2
                    class="select2 single"
                    v-model="country"
                    :options="countryOptions"
                    @select="selectCountry($event)"
                    placeholder="Country"
                  />
                </div>
                <div class="input-container">
                  <div class="desc">City:</div>
                  <input type="text" placeholder="City" v-model="city" />
                </div>
                <div class="input-container">
                  <div class="desc">Address:</div>
                  <input type="text" placeholder="Address" v-model="address" />
                </div>
                <div class="input-container">
                  <div class="desc">Post Code:</div>
                  <input
                    type="text"
                    placeholder="Post Code"
                    v-model="postCode"
                  />
                </div>

                <div class="buttons">
                  <button
                    class="button"
                    @click="handleCardPayout"
                    :disabled="!contactFieldsAreFilled"
                  >
                    <span>Card</span>
                  </button>
                  <button
                    class="button"
                    @click="showIbanForm"
                    :disabled="!contactFieldsAreFilled"
                  >
                    <span>IBAN</span>
                  </button>
                </div>
              </div>

              <!-- Step 2: IBAN Details -->
              <div class="form-fields-wrapper" v-if="ibanFormVisible">
                <div class="input-container">
                  <div class="desc">First Name:</div>
                  <input
                    type="text"
                    v-model="bank_holder_name"
                    placeholder="First Name"
                  />
                </div>
                <div class="input-container">
                  <div class="desc">Last Name:</div>
                  <input
                    type="text"
                    v-model="bank_holder_surname"
                    placeholder="Last Name"
                  />
                </div>
                <div class="input-container">
                  <div class="desc">IBAN:</div>
                  <input
                    type="text"
                    maxlength="34"
                    v-model="iban_number"
                    placeholder="IBAN"
                  />
                </div>
                <div class="cta-container">
                  <div class="chekbox-container">
                    <label class="chekbox-label">
                      <div class="chekbox-label-wrapper">
                        <input type="checkbox" name="terms" v-model="terms" />
                        <div class="checkbox"></div>
                        <span class="title"
                          >I agree with privacy policy and terms and
                          conditions</span
                        >
                      </div>
                    </label>
                  </div>
                </div>
                <div class="buttons">
                  <button class="button" @click="ibanFormVisible = false">
                    <span>Back</span>
                  </button>
                  <button
                    class="button"
                    @click="handleSepaPayout"
                    :disabled="!sepaFieldsAreFilled"
                  >
                    <span>Confirm</span>
                  </button>
                </div>
              </div>

              <transition name="slide">
                <div v-if="error" class="error-desc desc red">
                  {{ error }}
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "vue3-select2-component";

export default {
  name: "AcceptOfferModal",
  props: ["orderToView"],
  components: {
    Select2,
  },
  data: function () {
    return {
      ibanFormVisible: false,
      successVisible: false,
      email: "",
      name: "",
      surname: "",
      phone: "",
      country: "",
      city: "",
      address: "",
      postCode: "",
      terms: false,
      countryOptions: [],
      iban_number: "",
      bank_holder_name: "",
      bank_holder_surname: "",
      error: "",
    };
  },
  mounted() {
    this.getCounties();
    this.$http
      .get(process.env.VUE_APP_API + "user/profile")
      .then((res) => {
        this.email = res.data.email;
        this.name = res.data.name;
        this.surname = res.data.surname;
        this.phone = res.data.phone;
      })
      .catch((res) => {
        if (res.response.status === 401) this.$parent.openSignIn();
      });
  },
  computed: {
    contactFieldsAreFilled() {
      return (
        this.name &&
        this.surname &&
        this.email &&
        this.phone &&
        this.country &&
        this.city &&
        this.address &&
        this.postCode
      );
    },
    sepaFieldsAreFilled() {
      return (
        this.iban_number &&
        this.bank_holder_name &&
        this.bank_holder_surname &&
        this.terms
      );
    },
  },
  methods: {
    showIbanForm() {
      if (!this.contactFieldsAreFilled) return;
      this.error = ""; // Clear previous errors
      this.ibanFormVisible = true;
    },
    handleApiError(res) {
      let errorMsg = "An unknown error occurred.";
      if (res.response && res.response.data) {
        if (res.response.data.errors) {
          errorMsg = Object.values(res.response.data.errors)[0][0];
        } else if (res.response.data.message) {
          errorMsg = res.response.data.message;
        }
      }
      this.error = errorMsg;
    },
    buildContactPayload() {
      return {
        id: this.orderToView.id,
        name: this.name,
        surname: this.surname,
        email: this.email,
        phone: this.phone,
        country: this.country.iso,
        city: this.city,
        address: this.address,
        postCode: this.postCode,
        currency: this.orderToView.currency,
      };
    },
    handleCardPayout() {
      if (!this.contactFieldsAreFilled) return;
      this.error = "";
      const data = this.buildContactPayload();

      this.$http
        .post(process.env.VUE_APP_API + "offer/request-payout/card", data)
        .then((res) => {
          if (res.data.status === "OK" && res.data.redirect_url) {
            window.location.href = res.data.redirect_url;
          } else {
            this.error = res.data.message || "Could not initiate card payout.";
          }
        })
        .catch(this.handleApiError);
    },
    handleSepaPayout() {
      if (!this.sepaFieldsAreFilled) return;
      this.error = "";
      const data = {
        ...this.buildContactPayload(),
        account_number: this.iban_number,
        first_name: this.bank_holder_name,
        last_name: this.bank_holder_surname,
      };

      this.$http
        .post(process.env.VUE_APP_API + "offer/request-payout/sepa", data)
        .then(() => {
          this.successVisible = true;
          this.ibanFormVisible = false;
        })
        .catch(this.handleApiError);
    },
    selectCountry(event) {
      this.country = event.data;
    },
    getCounties() {
      this.$http
        .get(process.env.VUE_APP_API + "countries")
        .then((res) => {
          this.countryOptions = res.data.payload.map((item) => ({
            id: item.id,
            text: item.title,
            data: item,
          }));
        })
        .catch((res) => {
          if (res.response.status === 401) this.$parent.openSignInModal();
        });
    },
    close() {
      // If we just completed a successful payout, refresh the offer history
      if (this.successVisible) {
        this.$parent.getOfferHistory();
      }
      this.$emit("closeAcceptOfferModal");
    },
  },
  watch: {
    // When the modal is closed and reopened, reset its state
    "$parent.acceptOfferModalIsVisible"(newVal) {
      if (!newVal) {
        this.ibanFormVisible = false;
        this.successVisible = false;
        this.terms = false;
        this.iban_number = "";
        this.bank_holder_name = "";
        this.bank_holder_surname = "";
        this.error = "";
      }
    },
  },
};
</script>

<style scoped>
::v-deep(.select2) .select2-selection__rendered {
  height: 47px;
}
::v-deep(.select2) .select2-container {
  height: 47px;
  text-align: left;
  /* width: 300px !important; */
}
.modal .button {
  margin-top: 0;
}
.skin-modal .wrapper .form-fields-wrapper {
  display: flex;
  flex-direction: column;
  align-items: start;
}
.skin-modal .desc {
  width: 130px;
  text-align: left;
}
.third-step .desc {
  width: fit-content;
}
.skin-modal .input-container {
  padding-left: 0 !important;
  justify-content: start !important;
}
.skin-modal .input-container input {
  width: 238px;
  height: 47px;
}
.buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
  margin-top: 30px;
}

@media screen and (max-width: 768px) {
  .input-container {
    flex-direction: column;
    align-items: start;
  }
  .modal .wrapper .form input {
    margin-top: 0;
  }
  .buttons {
    flex-direction: column;
  }
}
</style>
